<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_iii"></a><a id="page_iv"></a><em class="italic">to Edward Upward</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?7a2a3196